import { DialogComponent } from "@theme/dialog";

/**
 * A custom element that manages a menu drawer.
 *
 * @extends {DialogComponent}
 */
class MenuDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.setupAccordionAnimations();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeAccordionListeners();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  /**
   * Sets up accordion animations for menu items with children
   */
  setupAccordionAnimations() {
    const detailsElements = this.querySelectorAll(".menu-drawer__details");

    detailsElements.forEach((details) => {
      const summary = details.querySelector("summary");
      const childList = details.querySelector("ul");

      if (!summary || !childList) return;

      // Calculate and set height when opening
      const handleToggle = () => {
        if (details.open) {
          // Temporarily set height to auto to measure
          childList.style.height = "auto";
          const height = childList.scrollHeight;
          childList.style.height = "0";

          // Force reflow
          childList.offsetHeight;

          // Set the calculated height
          childList.style.setProperty(
            "--menu-drawer-child-height",
            `${height}px`,
          );
          childList.style.height = `${height}px`;
        } else {
          // Reset height when closing
          childList.style.height = "0";
          childList.style.removeProperty("--menu-drawer-child-height");
        }
      };

      // Listen for toggle events
      details.addEventListener("toggle", handleToggle);

      // Store the handler for cleanup
      if (!details._menuDrawerToggleHandler) {
        details._menuDrawerToggleHandler = handleToggle;
      }
    });
  }

  /**
   * Removes accordion event listeners
   */
  removeAccordionListeners() {
    const detailsElements = this.querySelectorAll(".menu-drawer__details");

    detailsElements.forEach((details) => {
      if (details._menuDrawerToggleHandler) {
        details.removeEventListener("toggle", details._menuDrawerToggleHandler);
        delete details._menuDrawerToggleHandler;
      }
    });
  }
}

if (!customElements.get("menu-drawer-component")) {
  customElements.define("menu-drawer-component", MenuDrawerComponent);
}
